<template>
  <div>
    <!-- <el-button @click="$refs.drawerCommon.drawer=true">抽屉</el-button> -->
    <!-- {{deviceInfo.name}} -->
    <drawerCommon ref="drawerCommon"
                  v-if="isShow"
                  :initial-form-label-align="initialFormLabelAlign"
                  :form-array="formArray"
                  :dialog-form-array="dialogFormArray"
                  :drawer-rules="drawerRules"
                  @handleIcon="dialogVisible=true"
                  @handleClose="handleDrawerClose"
                  @onSubmit="onSubmit" >
      <template v-slot:header>
        <header>
          <span>设备编辑</span>
          <el-popover
            placement="top"
            trigger="click"
            v-model="visible">
            <el-button type="primary" size="mini" @click="handleRemove">删除</el-button>
            <i class="el-icon-more" slot="reference"></i>
          </el-popover>
        </header>
      </template>
      <template v-slot:footer>
        <el-divider></el-divider>
        <div class="device-info">
          <p>x: {{deviceInfo.x}}</p>
          <p>y: {{deviceInfo.y}}</p>
          <p>z: {{deviceInfo.z}}</p>
          <p>rx: {{deviceInfo.rx}}</p>
          <p>ry: {{deviceInfo.ry}}</p>
          <p>rz: {{deviceInfo.rz}}</p>
          <p>rw: {{deviceInfo.rw}}</p>
        </div>
      </template>
    </drawerCommon>
    <el-dialog title="新建NVR"
               :visible.sync="dialogVisible"
               width="30%"
               :before-close="handleClose">
      <formCommon :form-array="dialogFormArray"
                  :rules="rules"
                  @getData="dialogGetData" />
    </el-dialog>
  </div>
</template>

<script>
import drawerCommon from '@/components/drawer/drawerCommon.vue';
import formCommon from '@/components/form/formCommon.vue';
import eventHub from '@/utils/eventHub';
import { events } from '@/utils/events';
import { pointCreateDeviceInfo, pointDeviceInfo } from '@/api/devices';

export default {
  components: { drawerCommon, formCommon },
  data() {
    return {
      formArray: [
        {
          label: '名称',
          props: 'name',
          type: 'input',
        },
        {
          label: '设备类型',
          props: 'type',
          type: 'select',
          list: [
            {
              id: 'FE',
              name: 'FE',
            },
            {
              id: 'DID',
              name: 'DID',
            },
            {
              id: 'FID',
              name: 'FID',
            },
          ],
        },
        {
          label: '设备型号',
          props: 'model',
          type: 'input',
        },
        {
          label: '内网ip',
          props: 'ip',
          type: 'input',
        },
        {
          label: '外网映射端口',
          props: 'port_mapping',
          type: 'input',
        },
        {
          label: '账号',
          props: 'account',
          type: 'input',
        },
        {
          label: '密码',
          props: 'camera_pwd',
          type: 'input',
        },
        // {
        //   label: 'NVR',
        //   props: 'nvr_server_ip',
        //   type: 'select',
        //   icon: true,
        // },
        {
          label: '通道号',
          props: 'ch_num',
          type: 'input',
        },
        {
          label: '通道名称',
          props: 'ch_name',
          type: 'input',
        },
      ],
      dialogFormArray: [
        {
          label: '名称',
          props: 'name',
          type: 'input',
        },
        {
          label: 'ip',
          props: 'ip',
          type: 'input',
        },
        {
          label: '外网映射端口',
          props: 'port_mapping',
          type: 'input',
        },
        {
          label: 'NTP Server IP',
          props: 'ntp_server_ip',
          type: 'input',
        },
        {
          label: 'NTP端口号',
          props: 'ntp_port',
          type: 'input',
        },
        {
          label: '账号',
          props: 'account',
          type: 'input',
        },
        {
          label: '密码',
          props: 'camera_pwd',
          type: 'input',
        },
        {
          label: '下载端口映射',
          props: 'a',
          type: 'input',
        },
        {
          label: '录制开始时间',
          props: 'ch_name',
          type: 'timePicker',
        },
        {
          label: '录制结束时间',
          props: 'ch_name',
          type: 'timePicker',
        },
      ],
      rules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        ip: [
          { required: true, message: '请输入选择场', trigger: 'change' },
        ],
        port_mapping: [
          { required: true, message: '请输入外网映射端口', trigger: 'change' },
        ],
        ntp_server_ip: [
          { required: true, message: '请选择NTP Server IP', trigger: 'change' },
        ],
        ntp_port: [
          { required: true, message: '请输入NTP端口号', trigger: 'change' },
        ],
        account: [
          { required: true, message: '请输入账号', trigger: 'change' },
        ],
        camera_pwd: [
          { required: true, message: '请输入密码', trigger: 'change' },
        ],
      },
      drawerRules: {
        type: [
          { required: true, message: '请输入选择设备类型', trigger: 'change' },
        ],
      },
      dialogVisible: false,
      deviceInfo: {},
      visible: false,
      floorInfo: [],
      isShow: false,
      initialFormLabelAlign: {},
    };
  },
  created() {
    eventHub.$on(events.DEVICE_DOUBLE_CLICKED, this.eventDeviceDoubleChecked);
  },
  methods: {
    handleRemove() {
      this.visible = false;
      this.isShow = false;
      const { point_uuid: uuid } = this.deviceInfo;
      eventHub.$emit(events.REMOVE_DEVICE, uuid);
    },
    handleClose() { this.dialogVisible = false; },
    handleDrawerClose() {
      this.isShow = false;
    },
    dialogGetData() { },
    handleIcon() { this.dialogVisible = true; },
    eventDeviceDoubleChecked(device, floor) {
      const { deploy_id, device_type } = device;
      this.deviceInfo = device;
      this.floorInfo = floor;
      pointDeviceInfo({ deploy_id, device_type }).then((res) => {
        const { name, type, model, ip, port_mapping, account, camera_pwd, nvr_server_ip, ch_num, ch_name } = res.data;
        this.initialFormLabelAlign = { name, type, model, ip, port_mapping, account, camera_pwd, nvr_server_ip, ch_num, ch_name };
        this.isShow = true;
      });
    },
    onSubmit(val) {
      const params = {
        device_type: 1, // 设备类型
        deploy_id: this.deviceInfo.deploy_id, // 部署点位ID
        project_id: this.$route.query.place_id, // 项目ID
        place_id: this.$route.query.place_id, // 场ID
        floor_id: this.floorInfo.floor_id,
      };
      pointCreateDeviceInfo(Object.assign(params, val)).then(() => {
        this.isShow = false;
        this.$message({
          message: '提交成功',
          type: 'success',
        });
        eventHub.$emit(events.REFRESH_DEVICE_LIST);
      });
    },
  },
  beforeDestroy() {
    eventHub.$off(events.DEVICE_DOUBLE_CLICKED, this.eventDeviceDoubleChecked);
  },
};
</script>
<style lang='less' scoped>
 header{
    background: #ececec;
    height: 50px;
    padding: 0 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .device-info{
    padding: 0 20px;
    p{
      margin: 0;
    }
  }
</style>
